import {Injectable} from "@angular/core";
import {TradeCrudComponent} from "../../../crystal-clear/support/trade-crud/trade-crud.component";
import {Trade} from "../../../model/clearing/trade";
import {resolveFieldTypes} from "../../../utils/object-reflection";
import {TableColumnUtils} from "../../../utils/table-column-utils";
import {AccountDefinition} from "../../../model/customer/account-definition";
import CallPut = Trade.CallPut;
import {TableColumnConfig} from "../../../model/api/table-column-config";

@Injectable({providedIn: 'root'})
export class SupportTradeTableConfigService {

  private readonly fieldTypes = resolveFieldTypes<Trade>({
    side: 'enum',
    state: 'enum',
    callPut: 'enum',
    agressorInd: 'enum',

    executionDate: 'date',
    businessDate: 'date',
    clearingDate: 'date',

    creationDate: 'datetime',
    modificationDate: 'datetime',

    clearings: 'array',
    clearingInfo: 'object',

    giveIn: 'boolean',
    giveUp: 'boolean',
    finalPrice: 'boolean',
    exchangeMatched: 'boolean',
    reversalRequested: 'boolean',
    reversalRejected: 'boolean',
  });

  loadConfig(component: TradeCrudComponent) {

    const tableConfig: TableColumnConfig[] = (Object.keys(component.newRecord ?? {}) as Array<keyof Trade>)
      .filter(field => !this.isExcluded(field))
      .map(field => {
        const type = this.fieldTypes[field];

        const column = TableColumnUtils.buildColumn<Trade>(
          field,
          type,
          this.tradeOverrides(field, type)
        );

        TradeTableFilters.apply(column, field);
        return column;
      });

    tableConfig.forEach(columnConfig => {
      if (columnConfig.field === 'id'
        ||columnConfig.field === 'parentId') {
        columnConfig.width = 250;
      }
    })

    return tableConfig;
  }

  private tradeOverrides(field: keyof Trade, type: any) {
    if (field === 'account') {
      return {
        mapId: (record: Trade) => record.account?.name
      };
    }

    if (type === 'boolean') {
      return {
        icon: TableColumnUtils.booleanIcon<Trade>(field),
        mapId: TableColumnUtils.booleanMapId()
      };
    }

    return {};
  }

  private isExcluded(field: keyof Trade): boolean {
    return [
      'clearings',
      'clearingInfo'
    ].includes(field as string);
  }
}


export class TradeTableFilters {

  static apply(column: TableColumnConfig, field: keyof Trade): void {

    const f = field.toLowerCase();

    const filterType =
      ['businessdate', 'clearingdate', 'creationdate', 'executiondate'].includes(f) ? 'date' :
        ['volume', 'price', 'avgprice', 'avgrndprice', 'avgpriceresidual', 'overrideavgprice', 'strike', 'strategymissing'].includes(f) ? 'numeric' :
          ['side', 'openclose'].includes(f) ? undefined :
            'text';

    column.filterConfig = {
      type: filterType,
      matchMode: filterType === 'text' ? 'contains' : undefined,
      values: undefined
    };

    if (field === 'side') {
      column.filterConfig.values = Object.values(Trade.Side);
      column.filterConfig.matchMode = 'equals';
    } else if (field === 'openClose') {
      column.filterConfig.values = Object.values(AccountDefinition.OpenClose);
      column.filterConfig.matchMode = 'in';
    } else if (field === 'callPut') {
      column.filterConfig.values = Object.values(CallPut);
      column.filterConfig.matchMode = 'in';
    }
  }
}
